<template>
    <div class="example-modal-content popupJia successPopup" :class="{'popupJiaPC':$store.state.innerWidth>768}">
        <div class="popupTitleJia center">
            <div style="width:100%;">
            <div class="successImg">
                <img src="../images/Flat icon-52.png" />
            </div>
            <p class="popupTitleH1Jia center" style="width:100%;">{{title}}</p>
            </div>
        </div>
        <div v-html="text" class="popup-c"></div>
    </div>
</template>
<script>


export default {
    props: ['text', 'title'],
    methods: {
        closeByEvent() {
            this.$emit('close');
        }
    }
}
</script>

<style type="text/css">
    #modals-container{
             z-index:999999
    }
    .v--modal-background-click{
      
    }
	.v--modal-overlay{
            background: rgba(0, 0, 0, 0.8) !important;
         
    }
    .popupJia{
        padding: 40px;
    }
    .departmentJia{
        display: flex;
        flex-direction: column;
     
    }
    .popupTitleJia{
        display: flex;
        justify-content: space-between;
        align-items: center;
        align-content: center;
        
    }
    .popup-a{
        color: rgb(34,34,93);

        padding-bottom: 1px;
    }
    .popup-link{
      
        display: inline-block;
        /* border-bottom: 1px solid rgba(0, 0, 0, 0.8);*/
        margin-bottom: 12px;
        margin-top: 26px; 
    }
    .i-closeJia{
        color: rgb(34,34,93);
        font-size: 26px;
        margin-top: 5px;
    }
</style>